module.exports = __webpack_public_path__ + "img/ape-constructor-arrow-left.ee0c52e1.svg";